"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Action = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Action = exports.Action = function Action() {
  return null;
};
Action.propTypes = {
  id: _propTypes["default"].string,
  button: _propTypes["default"].bool,
  icon: _propTypes["default"].node,
  iconContent: _propTypes["default"].bool,
  tooltip: _propTypes["default"].string,
  label: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  variant: _propTypes["default"].string,
  component: _propTypes["default"].elementType,
  componentProps: _propTypes["default"].object,
  add: _propTypes["default"].bool,
  accent: _propTypes["default"].bool,
  selected: _propTypes["default"].bool,
  size: _propTypes["default"].string
};